module.exports = {
  title: '询价列表',
  route: {
    path: '/inquery-manage',
    children: {
      path: 'inquery-list',
    },
  },
};
